import { render, staticRenderFns } from "./AuctionStatusChip.vue?vue&type=template&id=50240c65&scoped=true"
import script from "./AuctionStatusChip.vue?vue&type=script&lang=js"
export * from "./AuctionStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50240c65",
  null
  
)

export default component.exports